import { useLocation } from "react-router-dom"

export const useIsRoute = () => {
  const { pathname } = useLocation()
  const isRoute = (path: string = "") => pathname === path
  return {
    isRoute
  }
}
